import { Component } from '@angular/core';

@Component({
  selector: 'faqs-view',
  templateUrl: './faqs-view.component.html',
  styleUrls: ['./faqs-view.component.scss']
})
export class FaqsViewComponent {}
